const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    contract_id: {
      type: 'string',
      title: 'contract',
    },
    cost: {
      type: 'string',
      title: 'pay',
    },
    reported_in: {
      type: 'string',
      title: 'report_number',
    },
    description: {
      type: 'string',
      title: 'description',
    },
  },
});

export default schema;
